function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:#B1C3CC;}\n");

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "Shape",
  className: "st0",
  d: "M4,11c1.1,0,2-0.9,2-2S5.1,7,4,7S2,7.9,2,9S2.9,11,4,11z M3.1,13.1c-0.4-0.1-1.1,0.1-1.9,0.5 c-0.7,0.3-1.2,1-1.2,1.9V17h2.5v-1.6C2.5,14.6,2.7,13.8,3.1,13.1z M16,11c1.1,0,2-0.9,2-2s-0.9-2-2-2s-2,0.9-2,2S14.9,11,16,11z  M20,15.4c0-0.8-0.5-1.5-1.2-1.9c-0.9-0.4-1.5-0.5-1.9-0.5c0.4,0.7,0.6,1.5,0.6,2.3V17H20V15.4z M14.2,12.6 c-1.2-0.5-2.6-0.9-4.2-0.9s-3.1,0.4-4.2,0.9C4.7,13.1,4,14.2,4,15.4V17h12v-1.6C16,14.2,15.3,13.1,14.2,12.6z M6.1,15 c0.1-0.2,0.1-0.4,0.9-0.7c1-0.4,2-0.6,3-0.6s2.1,0.2,3,0.6c0.8,0.3,0.8,0.5,0.9,0.7H6.1z M10,5c0.6,0,1,0.4,1,1s-0.4,1-1,1 S9,6.5,9,6S9.4,5,10,5 M10,3C8.3,3,7,4.3,7,6s1.3,3,3,3s3-1.3,3-3S11.7,3,10,3L10,3z"
});

var SvgLeadPerson = function SvgLeadPerson(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 20 20",
    style: {
      enableBackground: "new 0 0 20 20"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgLeadPerson, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/lead_person.8a814064.svg";
export { ForwardRef as ReactComponent };